require('./commonBundle/models/NavigationPreference');
require('./commonBundle/gateways/navigationPreferenceGateway');
require('./commonBundle/common/errorFactory');
require('./commonBundle/class/Queue');
require('./commonBundle/common/router');

require('./SdZ/modules/utils/font');
require('../Widgets/baseWidget');

require('./SdZ/widgets/autocompletefield');
require('./SdZ/widgets/tagsSelect');
require('./SdZ/widgets/dismissibleElement');
require('./SdZ/widgets/ajaxForm');

require('./commonBundle/widgets/formEvents');
require('./commonBundle/widgets/courseSearch');
require('./commonBundle/widgets/tabs');
require('./commonBundle/widgets/popOut');

require('./SdZ/modules/header');
require('./SdZ/modules/common');
require('./SdZ/modules/mediapopup');
require('./SdZ/modules/tooltip');
require('./SdZ/modules/date-picker');
require('./SdZ/widgets/classname-switcher');
require('./SdZ/modules/autocomplete-search');

require('./commonBundle/widgets/highlite');
require('./commonBundle/widgets/selectValue');

require('../../../../../SimpleIT/ThreadBundle/Resources/public/js/widgets/threadPost');
require('../../../../../SimpleIT/ThreadBundle/Resources/public/js/widgets/message-list');
require('../../../../../SimpleIT/ThreadBundle/Resources/public/js/modules/interventions');
require('../../../../../SimpleIT/ThreadBundle/Resources/public/js/modules/postWrite');
require('../../../../../SimpleIT/ThreadBundle/Resources/public/js/modules/postsList');
require('../../../../../SimpleIT/ThreadBundle/Resources/public/js/modules/pm');
